export enum CompanyTabs {
  CompanyDetails = 'company-details',
  CompanyIbans = 'company-ibans'
}
